import type { AdminStudioListItem } from "@shared-kernel/application/ports/admin/admin-repository";
import { SUPPORTED_COUNTRY } from "@shared-kernel/domain/types/supported-country";
import { mockStudioEnvironment } from "./studio-environment";

export const studios: AdminStudioListItem[] = [
  {
    id: "1",
    name: "Studio Mozart",
    postalAddress: {
      address: "123 rue de la Musique",
      city: "Paris",
      postalCode: "75001",
      latitude: 48.8606,
      longitude: 2.3376,
      externalPlaceId: null,
      addressComplement: null,
      country: SUPPORTED_COUNTRY.FRANCE,
      department: null,
      region: null,
    },
    equipmentDescription: "Piano à queue Steinway, système audio professionnel",
    photoUrls: [],
    price: 50,
    isMobilityAccessible: true,
    environment: mockStudioEnvironment,
  },
  {
    id: "2",
    name: "Studio Beethoven",
    postalAddress: {
      address: "45 avenue des Arts",
      city: "Paris",
      postalCode: "75002",
      latitude: 48.8685,
      longitude: 2.3439,
      externalPlaceId: null,
      addressComplement: null,
      country: SUPPORTED_COUNTRY.FRANCE,
      department: null,
      region: null,
    },
    equipmentDescription: "Piano droit Yamaha, microphones Neumann",
    photoUrls: [],
    price: 40,
    isMobilityAccessible: false,
    environment: mockStudioEnvironment,
  },
];
